import { render } from "./HomeBodyPage.vue?vue&type=template&id=179983bc&scoped=true"
import script from "./HomeBodyPage.vue?vue&type=script&lang=js"
export * from "./HomeBodyPage.vue?vue&type=script&lang=js"

import "./HomeBodyPage.vue?vue&type=style&index=0&id=179983bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179983bc"]])

export default __exports__